export default "__VITE_ASSET__5f8434e5__"